import type { ReactNode } from "react";
import { RouteScroller } from "@client/components/utils/RouteScroller";
import { LoginPanel } from "./LoginButton";
import "./welcomeLanding.css";

export function WelcomeLanding({
  error,
  applications,
}: {
  error?: string;
  applications?: ReactNode;
}) {
  return (
    <RouteScroller className="bg-background">
      <span hidden data-application-theme="green" />
      <main className="welcome-layout mx-auto flex min-h-full w-full max-w-6xl flex-col justify-center px-6 py-10 sm:px-8 lg:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[minmax(0,1fr)_27.5rem] lg:gap-20">
          <section className="mx-auto w-full max-w-lg lg:mx-0">
            <p className="mb-4 body-md text-muted-foreground">
              Survival &amp; Flourishing Fund
            </p>
            <h1 className="welcome-headline text-3xl min-[360px]:text-4xl leading-[1.08] tracking-[-0.03em] text-balance md:text-5xl">
              Empowering organizations to secure humanity’s future
            </h1>
            <p className="mt-6 max-w-md body-lg text-muted-foreground">
              Apply for funding, follow your application, or help decide which
              work to support.
            </p>
            {applications}
            <p className="mt-6 body-sm text-muted-foreground">
              <a
                href="https://survivalandflourishing.fund/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Learn about Survival & Flourishing Fund (opens in a new tab)"
                className="rounded-sm underline underline-offset-4 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring"
              >
                Learn about Survival &amp; Flourishing Fund ↗
              </a>
            </p>
          </section>

          <section
            aria-labelledby="welcome-sign-in"
            className="mx-auto w-full max-w-[27.5rem] rounded-xl border border-border bg-card p-4 min-[360px]:p-6 sm:p-8 lg:justify-self-end"
          >
            <h2 id="welcome-sign-in" className="heading-lg">
              Welcome to S-Process
            </h2>
            <p className="mb-8 mt-2 body-md text-muted-foreground">
              Your applications and funding rounds, in one place.
            </p>
            <LoginPanel variant="welcome" />
            {error && (
              <p role="alert" className="mt-4 body-md text-destructive">
                Error: {error}
              </p>
            )}
          </section>
        </div>
      </main>
    </RouteScroller>
  );
}
